export type DocsLink = {
  name: string;
  link: string;
};

export const DOCS: DocsLink[] = [
  {
    name: 'Quick Start Guide',
    link: 'https://docs.dataswift.io/build/getting-started',
  },
  {
    name: 'Platform Overview',
    link: 'https://docs.dataswift.io/learn/platform-overview',
  },
  {
    name: 'API Information',
    link: 'https://api.dataswift.io/',
  },
  {
    name: 'Github',
    link: 'https://github.com/dataswift',
  },
];
